import { NavLink, useLocation } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { navData, navDataBottom } from "../lib/navData";
import { useMemo, useState } from "react";
import logoLeaf from "../assets/logo_leaf.png";
import logo from "../assets/logo.png"; // adjust path as needed

function usePathname() {
  const { pathname } = useLocation();
  return useMemo(() => pathname, [pathname]);
}

export default function Sidenav({ open, setOpen }) {
  const pathname = usePathname();

  const renderItem = (item) => {
    const active = item.link === pathname;

    return (
      <NavLink
        key={item.id}
        to={item.link}
        className={`
          group relative flex items-center gap-3 mx-2 mb-1 px-3 py-3 rounded-xl
          text-[0.8rem] capitalize transition-all duration-200 ease-out
          ${active
            ? "bg-orange-500/15 text-white font-semibold"
            : "text-white/60 font-normal hover:bg-white/5 hover:text-white hover:translate-x-0.5"}
        `}
      >
        {active && (
          <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-[3px] rounded-full bg-orange-500" />
        )}

        <span
          className={`flex items-center justify-center w-6 h-6 shrink-0 transition-colors duration-200
            ${active ? "text-orange-500" : "text-white/70 group-hover:text-white"}`}
        >
          {item.icon}
        </span>

        <span
          className={`whitespace-nowrap overflow-hidden transition-all duration-200
            ${open ? "opacity-100 max-w-[160px]" : "opacity-0 max-w-0"}`}
        >
          {item.text}
        </span>

        {!open && (
          <span
            className="pointer-events-none absolute left-full ml-3 whitespace-nowrap rounded-md
              bg-[#1b1b3a] px-2 py-1 text-xs text-white opacity-0 shadow-lg
              group-hover:opacity-100 transition-opacity duration-150 z-50"
          >
            {item.text}
          </span>
        )}
      </NavLink>
    );
  };

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      className={`
        flex
flex-col
w-full
h-[calc(100vh-24px)]
my-3
ml-3
bg-gradient-to-b
from-[#1b1b3a]
to-[#262673]
rounded-2xl
shadow-[4px_0_20px_rgba(0,0,0,0.25)]
py-3
      `}
    >
      {/* Logo section */}
      <div
        className={`flex items-center gap-2 px-3 mb-4 h-10 shrink-0
          ${open ? "justify-center" : "justify-center"}`}
      >
        
        {open && (
          <img
          src={logo}
          alt="Logo"
          className="h-16 w-44 shrink-0 object-contain"
        />
        )}

       {!open && (
          <img
          src={logoLeaf}
          alt="Logo"
          className="h-8 w-8 shrink-0 object-contain"
        />
        )
        
        
        }
      </div>

      <div className="mx-3 mb-3 border-t border-white/10" />

      {/* <button
        onClick={() => setOpen((p) => !p)}
        className="mx-auto mb-4 flex h-8 w-8 items-center justify-center rounded-lg
          bg-white/5 text-white transition-colors duration-200
          hover:bg-orange-500/20 hover:text-orange-500"
      >
        {open ? (
          <KeyboardDoubleArrowLeftIcon style={{ fontSize: "1.2rem" }} />
        ) : (
          <KeyboardDoubleArrowRightIcon style={{ fontSize: "1.2rem" }} />
        )}
      </button> */}

      <div className="flex flex-col">
        {navData.map(renderItem)}
      </div>

      <div className="my-4 mx-3 border-t border-white/10" />

      <div className="mt-auto flex flex-col">
        {navDataBottom.map(renderItem)}
      </div>
    </div>
  );
}